import { module } from 'modujs'


/* 
// USAGE :
//  data-accordion-toggle = auto close already open accordion
//  data-accordion-scroll = Scroll to open accordion
//  data-accordion-preopen="0" = Pre Open accordion matching index
<div class="c-accordion" data-module="Accordion" data-accordion-toggle data-accordion-scroll data-accordion-preopen="0">
    <?php for($i=1; $i<=8; $i++): ?>
        <div class="c-accordion__section js-animate" data-accordion="wrap">
            <div class="c-accordion__header">
                <h3 class="c-accordion__header__title">
                    <?php $accordionTitle = "Titre de mon accordion - ".$i; ?>
                    <button class="c-accordion__button" aria-expanded="false" data-accordion="trigger" type="button" aria-label="Ouvrir <?=$accordionTitle; ?>">
                        <?=$accordionTitle; ?>
                    </button>
                </h3>
            </div>
            <div class="c-accordion__content" role="region" data-accordion="content">
                <div class="c-accordion__inner">
                    <article class="o-text">
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellat rem nisi soluta commodi harum deleniti, voluptatem itaque doloremque temporibus labore fugit iusto nesciunt esse rerum vitae, deserunt quidem aliquid error!</p>
                    </article>
                </div>
            </div>
        </div>
    <?php endfor; ?>
</div>
*/

const PARAM = {
    OPEN: `is-open`,
    SCROLLTO: true,
    HEADER: 100
}

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                trigger: 'toggle'
            }
        }
    }

    setAttributes(el, attrs) {
        for (var key in attrs) {
            el.setAttribute(key, attrs[key]);
        }
    }

    init() {

        window.toggleChildsTabindex = function (el, state) {
            let childs = el.querySelectorAll('a, button, input, select, textarea, [tabindex]');
            childs.forEach(child => {
                child.setAttribute('tabindex', state);
            })
        }
        
        let moduleEl = this.el;
        let moduleId = moduleEl.getAttribute('data-mid');

        let accordionTriggers = moduleEl.querySelectorAll('[data-accordion="trigger"]');
        let accordionContents = moduleEl.querySelectorAll('[data-accordion="content"]');

        if (accordionTriggers.length != accordionContents.length) {
            console.error('Accordion : Number of triggers and contents does not match');
        }

        let i = 1;
        accordionTriggers.forEach(trigger => {
            this.setAttributes(trigger, {
                'id': moduleId + '-trigger-' + i,
                'aria-controls': moduleId + '-target-' + i,
                'aria-selected': "true",
                'aria-expanded': "false",
                'tabindex': '0'
            })
            i++;
        });

        let j = 1;
        accordionContents.forEach(content => {
            this.setAttributes(content, {
                'aria-labelledby': moduleId + '-trigger-' + j,
                'id': moduleId + '-target-' + j,
                'role': 'region',
                'tabindex': '-1',
            })

            toggleChildsTabindex(content, '-1');

            j++;
        });

        let preOpenId = moduleEl.getAttribute('data-accordion-preopen');
        if (preOpenId) {
            let preOpenElement = accordionContents[preOpenId];
            preOpenElement.style.maxHeight = preOpenElement.scrollHeight + "px"
            //preOpenElement.setAttribute('tabindex','0');
            preOpenElement.closest('[data-accordion="wrap"]').classList.add(PARAM.OPEN);
            toggleChildsTabindex(preOpenElement, '0');
        }

    }

    /**
     * Toggle Action
     *
     * @param el {node}
     */
    toggle(el) {
        let target = el.currentTarget
        let parent = target.closest('[data-accordion="wrap"]')
        if (parent.classList.contains(PARAM.OPEN)) {
            this.close()
        } else {
            this.close()
            this.open(parent)
        }
    }

    /**
     * Open Action
     *
     * @param el {node}
     */
    open(el) {
        el.classList.add(PARAM.OPEN);
        let curContent = el.querySelector('[data-accordion="content"]')
        let curTrigger = el.querySelector('[data-accordion="trigger"]')

        curContent.style.maxHeight = curContent.scrollHeight + "px"
        curTrigger.setAttribute('aria-expanded', 'true')
        //curContent.setAttribute('tabindex','0')
        toggleChildsTabindex(curContent, '0')

        if (PARAM.SCROLLTO) {
            setTimeout(function () {
                let newTop = window.pageYOffset + el.getBoundingClientRect().top - PARAM.HEADER;
                window.scrollTo({
                    top: newTop,
                    behavior: 'smooth'
                })
            }, 500)
        }
    }

    /**
     * Close Action
     *
     * @param
     */
    close() {
        this.$('wrap').forEach((item) => {
            let curTrigger = item.querySelector('[data-accordion="trigger"]')
            let curContent = item.querySelector('[data-accordion="content"]')
            item.classList.remove(PARAM.OPEN)
            curTrigger.setAttribute('aria-expanded', 'false');
            curContent.setAttribute('tabindex', '-1');
            curContent.style.maxHeight = null
            toggleChildsTabindex(curContent, '-1');
        })
    }
}
